var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.role.id)?_c('div',[_c('h4',[_vm._v("Role: "+_vm._s(_vm.role.name))]),_vm._v(" "),_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }